import { request, history, getLocale } from 'umi'
import { baseUrl } from '../config'
import { getToken, getUrlParam } from './getValue'
import { Toast } from 'antd-mobile'
import { getStorage, removeStorage } from './onStorage'
import { getValue } from './getValue'
import goTo from './goTo'
import loading from './loading'
import React from 'react'
import getChannelBridgeApi from './appAdapter'
import { transLangKeysForBoss } from './lang'
import { trackError, trackErrorboundary, trackEvent, trackMetaData } from './track'
import { CUSTOMIZE_LOGIN_REDIRECT_URL } from '../constant'

interface RequestError {
  data: any | null
  request: any
  response: any | null
  type: string
  message: string
  stack: string
  info: null | any
}

type method =
  | 'OPTIONS'
  | 'GET'
  | 'HEAD'
  | 'POST'
  | 'PUT'
  | 'DELETE'
  | 'TRACE'
  | 'CONNECT'
  | undefined

type Options = {
  isShowMessage?: boolean // 是否自动提示
  headers?: any // 头部信息
  returnData?: boolean // true只返回data，false返回整个res
  hasLoading?: boolean
  resolveData?: boolean // 失败的时候是否需要返回数据
}

interface RequestParams {
  uri?: string // 请求的api 会自动拼上baseUrl
  requestUrl?: string //请求url 若传了这个就不会走拼baseurl,请求链接等级最高，通常用于请求非baseurl外的链接
  params?: any //  请求参数
  method?: method // 请求方式 默认post
  options?: Options // 请求的其他参数，比如拼上头部信息等
}

export interface RequestFn {
  <T>(params: RequestParams): Promise<T>
}

// token是否有变动，用于监听打开新窗口 如果 true 则中断请求返回登录页
const isChangeToken = (uri?: string) => {
  try {
    const pathname = history.location.pathname
    const truePage = ['/login']
    const isPassPage = truePage.includes(pathname)
    if (isPassPage) return true
  } catch (error) { }
  let isChange = false

  return isChange
}

function shouldRunOnce(key: string, wait: number) {
  const g: any = globalThis as any
  const store = (g.__onceLocks__ = g.__onceLocks__ || {})
  const now = Date.now()
  const last = store[key] || 0
  if (now - last < wait) return false
  store[key] = now
  setTimeout(() => {
    const s = (globalThis as any).__onceLocks__
    if (s && s[key] === now) delete s[key]
  }, wait)
  return true
}

export const toLogin = () => {
  console.log('tologin call')
  // 10秒内 防止多次跳登录页，小程序多次跳转
  if (!shouldRunOnce('toLogin', 3500)) return
  console.log('tologin reach')
  const channel = getStorage('channel') || getUrlParam('channel')
  const { goToLogin } = getChannelBridgeApi(channel)
  // 登录后回调到指定的url，并非前一个处于未登录状态的页面
  const redirectUrlFromStorage = getStorage(CUSTOMIZE_LOGIN_REDIRECT_URL) || ''
  const tenantCode = getValue('tenantCode')
  const redirectUrl = redirectUrlFromStorage || window.location.hash.replace('#', '')
  console.log('login redirectUrl: ', redirectUrl)
  if (redirectUrlFromStorage) {
    removeStorage(CUSTOMIZE_LOGIN_REDIRECT_URL)
  }
  if (goToLogin && typeof goToLogin === 'function') {
    goToLogin({
      redirectUrl: encodeURIComponent(redirectUrl),
    })
    return
  }
  goTo(
    `/login?tenantCode=${tenantCode}&redirect=${encodeURIComponent(redirectUrl)}`,
    {
      type: 'replace',
      time: 500,
    },
  )
}


const doRequest: RequestFn = ({
  uri,
  requestUrl,
  params = {},
  method = 'POST',
  options = {},
}) => {
  const token = getToken('h5Token')
  const qrcodeToken = getToken('qrcodeToken')

  isChangeToken(uri)
  const {
    isShowMessage = true,
    headers = {}, // 头部参数
    returnData = true, // true只返回data，false返回整个res
    hasLoading = true, // 请求显示loading
    resolveData = false, // 失败是否返回值
  } = options || {}
  const isGet = method === 'GET'

  return new Promise((resolve, reject) => {
    try {
      const url = requestUrl || `${uri}`
      hasLoading && loading.show()
      const locale = getLocale()
      const bossLocale = transLangKeysForBoss(locale)
      const stringifyParams = JSON.stringify({
        lg: bossLocale,
        ...params,
      })

      const requestData = {
        requestParams: isGet ? stringifyParams : '',
        requestBody: isGet ? '' : stringifyParams,
        requestHeaders: {
          ...headers,
          'HTTP-HEADER-LANGUAGE': locale,
          'Accept-Language': bossLocale,
          'h5-token': token,
          'qrcode-token': qrcodeToken,
        }
      }

      try {
        if (window.ineum) {
        // if (isGet) {
        //   trackMetaData('requestParams', stringifyParams)
        //   trackMetaData('requestBody', '')
        // } else {
        //   trackMetaData('requestBody', stringifyParams)
        //   trackMetaData('requestParams', '')
        // }
        // trackMetaData('requestHeaders', {
        //   ...headers,
        //   'HTTP-HEADER-LANGUAGE': locale,
        //   'Accept-Language': bossLocale,
        //   'h5-token': token,
        //   'qrcode-token': qrcodeToken,
        // })

        // console.log(`API_REQUEST ${url}`)
        // @ts-ignore
        trackEvent(`API_REQUEST`, {
          meta: {
            apiUrl: url,
            apiMethod: method,
            ...requestData,
          },
        })
        }
      } catch (error) {
        trackErrorboundary(error, 'trackEvent', `API_REQUEST`)
        console.log('ineum error', error)
      }
      request(url, {
        method,
        [isGet ? 'params' : 'data']: {
          lg: bossLocale,
          ...params,
        },
        headers: {
          ...headers,
          'HTTP-HEADER-LANGUAGE': locale,
          'Accept-Language': bossLocale,
          'h5-token': token,
          'qrcode-token': qrcodeToken,
        },
        skipErrorHandler: true,
      })
        .then((res: RequestResType) => {
        const _res = res || {}
        const { code, msg } = _res
        const isSuccess = code === 0
        
        try {
          // @ts-ignore
          trackEvent(`API_REQUEST_SUCCESS`, {
            meta: {
              apiUrl: url,
              apiMethod: method,
              responseData: JSON.stringify(res || {}),
              responseCode: '200',
              statusCode: String(code),
              errorMsg: msg || '',
              apiResultIsVaild: res ? 'true' : 'false',
              ...requestData,
            },
          })
        } catch (err) {
          trackEvent(`API_REQUEST_SUCCESSRESULT_UPLOAD_FAILED`, {
            meta: {
              apiUrl: url,
              apiMethod: method,
              statusCode: String(code),
              errorMsg: msg || '',
              apiResultIsVaild: res ? 'true' : 'false',
              ...requestData,
            },
          })
          trackErrorboundary(err, 'trackEvent', `‌API_REQUEST_SUCCESS`)
          console.error('instana upload error:', err)
        }

        if (!isSuccess && code !== 4001) {
          try {
            console.log(`‌API_SERVICE_ERROR ${url}`)
            // @ts-ignore
            trackError(`‌API_SERVICE_ERROR ${url}`, {
              meta: {
                apiUrl: url,
                method,
                responseData: JSON.stringify(res || {}),
                errorMsg: res?.msg || '服务繁忙，请稍后再试~',
                errorData: res?.data || {},
                // @ts-ignore
                errorCode: res?.code,
                errorInfo: JSON.stringify(res || {}),
                data: stringifyParams,
                'h5-token': token,
                'qrcode-token': qrcodeToken,
                ...requestData,
              },
            })
            hasLoading && loading.hide()
          } catch (err) { 
            trackErrorboundary(err, 'trackError', `‌API_SERVICE_ERROR ${url}`)
          }
        }
        if (code === 4001) {
          try {
            removeStorage('h5Token')
            removeStorage('qrcodeToken')
            removeStorage('geolocationCity')
            removeStorage('couponCheckResp')
            removeStorage('memberCode')
            removeStorage('guestCode')
            removeStorage('openId')
            // 用户第一次进入，直接跳转登录
            if (token || qrcodeToken) {
              Toast.show({
                icon: 'fail',
                content: window.lang ? lang?.['登录状态过期'] : '登录状态过期',
              })
              toLogin()
            } else {
              toLogin()
            }
            window.dpTracker?.anonymous()
          } catch (error) {
            console.log('request重新登录错误')
          }
          return
        }
        const noTipText = ['success', ''] // 不需要提示的文案
        const tips = res.msg || ''
        const isNeedTip = !noTipText.includes(tips) //
        if (isNeedTip && isShowMessage && tips) {
          const msgType = isSuccess ? 'success' : ''
          Toast.show({
            icon: msgType,
            content: React.createElement('p', {
              dangerouslySetInnerHTML: { __html: tips },
            }),
          })
        }
        if (isSuccess) {
          const resData = res.data
          const result = returnData ? resData : res
          resolve(result)
        } else {
          resolveData ? resolve(res) : reject(res)
        }
      })
        .catch((err: RequestError, info: any) => {
        console.log('catch >>>>> err stringify', {
          errorInfo: JSON.stringify(err || {}),
          errorResponse: err.response || '',
        })
        try {
          // HttpError 错误 4XX/5XX 才有err.response
          if (!err.response) err.response = {}
          trackError(new Error(`API_REQUEST_ERROR`), {
            meta: {
              apiUrl: url,
              apiMethod: method,
              responseData: null,
              responseStatus: err?.response?.status,
              responseStatusText: err?.response?.statusText,
              responseHeaders: err?.response?.headers,
              responseBody: err?.response?.data,
              errorMsg: err?.message,
              errorType: err?.type,
              errorStack: err?.stack,
              errorTag: err.type === 'HttpError' && err.response ? '服务器 4xx/5xx 错误码报错' : 'TCP/IP/DNS/CORS 或 fetch/XHR API网络错误',
              ...requestData,
            },
          })
        } catch (err) {
          trackErrorboundary(err, 'trackError', 'API_REQUEST_ERROR')
          console.error('instana upload error:', err)
        }
        reject(err)
        isShowMessage &&
          Toast.show({
            content: React.createElement('p', {
              dangerouslySetInnerHTML: {
                __html:
                  err?.msg ||
                  (window.lang
                    ? lang?.['服务繁忙，请稍后再试~']
                    : '服务繁忙，请稍后再试~'),
              },
            }),
          })
        })
        .finally(() => {
          hasLoading && loading.hide()
          // trackMetaData('requestParams', '')
          // trackMetaData('requestBody', '')
          // trackMetaData('requestBody', '')
          // trackMetaData('requestParams', '')
          // trackMetaData('requestHeaders', '')
        })
    } catch (error) {
      hasLoading && loading.hide()
      reject(error)
    }
  })
}

const responseToJsonString = (response: Response) => {
  if (!response) return null;
  return JSON.stringify({
    url: response.url,
    status: response.status,
    statusText: response.statusText,
    ok: response.ok,
    redirected: response.redirected,
    type: response.type,
    headers: Object.fromEntries(response.headers.entries())
  })
}

export default doRequest
